module.exports = __webpack_public_path__ + "static/media/fancy_2_bottom.7f5e8cd9.svg";